import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function LanguangeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m8.545 13.5.744-1.65M14 13.5l-.744-1.65m0 0-1.983-4.4-1.984 4.4m3.967 0H9.29m-6.198 0c3.32-2.78 4.511-4.615 6-8.25m0 0h1.09m-1.09 0H6.364M2 3.6h4.364m0 0V2.5M4.182 5.8C5.5 8.033 6.332 9.01 8 10.2" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m8.545 13.5.744-1.65M14 13.5l-.744-1.65m0 0-1.983-4.4-1.984 4.4m3.967 0H9.29m-6.198 0c3.32-2.78 4.511-4.615 6-8.25m0 0h1.09m-1.09 0H6.364M2 3.6h4.364m0 0V2.5M4.182 5.8C5.5 8.033 6.332 9.01 8 10.2" /></svg>
  );
}

export default LanguangeIcon;
